import { useEffect } from "react";
import "@/App.css";
import "@/lib/auth";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import BlogPost from "@/pages/BlogPost";
import Store from "@/pages/Store";
import StoreSuccess from "@/pages/StoreSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ShopLayout from "@/shop/ShopLayout";
import ShopHome from "@/shop/ShopHome";
import ShopAll from "@/shop/ShopAll";
import ProductDetail from "@/shop/ProductDetail";
import { Collections, CollectionDetail } from "@/shop/Collections";
import { TrackOrder, ShopAbout, ShopContact } from "@/shop/ShopPages";
import ChatWidget from "@/components/ChatWidget";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    document.title = "James Douglas — Creating Experiences That Inspire";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/store" element={<Store />} />
          <Route path="/store/success" element={<StoreSuccess />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/shop" element={<ShopLayout />}>
            <Route index element={<ShopHome />} />
            <Route path="all" element={<ShopAll />} />
            <Route path="product/:handle" element={<ProductDetail />} />
            <Route path="collections" element={<Collections />} />
            <Route path="collections/:handle" element={<CollectionDetail />} />
            <Route path="track" element={<TrackOrder />} />
            <Route path="about" element={<ShopAbout />} />
            <Route path="contact" element={<ShopContact />} />
          </Route>
        </Routes>
        <ChatWidget />
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
